import React from "react";
import { Paper, Box, Typography } from "@mui/material";
import { StatusDotBadge, getStatusBadgeConfig } from "./StatusBadge";

const CalendarCellItem = ({ item, onClick, isCompact = true }) => {
  const badge = getStatusBadgeConfig(item);
  const courseName = item.courses?.[0]?.name || "Class";

  if (isCompact) {
    return (
      <Paper
        elevation={0}
        onClick={onClick}
        sx={{
          p: 0.75,
          bgcolor: badge.bg,
          borderRadius: "6px",
          cursor: "pointer",
          border: "1px solid transparent",
          "&:hover": { borderColor: "#D0D5DD" },
        }}
      >
        <StatusDotBadge item={item} />
        <Typography
          variant="caption"
          display="block"
          fontWeight={600}
          color="#101828"
          noWrap
          sx={{ fontSize: "0.7rem", mt: 0.2 }}
        >
          {item.newTime || item.time} • {item.name || courseName}
        </Typography>
        <Typography variant="caption" color="#667085" sx={{ fontSize: "0.65rem" }}>
          {item.is_recurring === 1 ? "Recurring" : "One-Time"}
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper
      elevation={0}
      onClick={onClick}
      sx={{
        p: 1.25,
        bgcolor: badge.bg,
        borderRadius: "8px",
        cursor: "pointer",
        border: "1px solid transparent",
        "&:hover": { borderColor: "#D0D5DD" },
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
        <StatusDotBadge item={item} />
        <Typography variant="caption" color="#667085" fontSize="0.7rem">
          {item.is_recurring === 1 ? "Recurring" : "One-Time"}
        </Typography>
      </Box>
      <Typography variant="body2" fontWeight={600} color="#101828" sx={{ mt: 0.5 }}>
        {item.newTime || item.time} • {item.name || courseName}
      </Typography>
    </Paper>
  );
};

export default CalendarCellItem;